(() => {
  if (customElements.get('amazon-deals')) return;
  class AmazonDeals extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.catalog = [];
      this.items = new Map();
      try {
        this.catalog = JSON.parse(this.querySelector('[data-catalog]')?.dataset.catalog || '[]') || [];
        this.querySelectorAll('[data-category]').forEach(node => {
          const id = node.dataset.category;
          this.items.set(id, [...(this.items.get(id) || []), ...(JSON.parse(node.dataset.items || '[]') || [])]);
        });
      } catch (_) { this.querySelector('.ad-list').textContent = '商品暂时无法显示，请稍后刷新。'; return; }
      const nav = this.querySelector('.ad-tabs');
      this.storageKey = 'amazon-deals-category:' + location.pathname;
      let active = '';
      try { active = sessionStorage.getItem(this.storageKey) || ''; } catch (_) {}
      if (!this.catalog.some(cat => cat.id === active)) active = '';
      [{id:'',name:'全部'}, ...this.catalog].forEach(cat => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ad-tab'; button.textContent = cat.name;
        button.setAttribute('aria-pressed', String(cat.id === active));
        button.addEventListener('click', () => {
          nav.querySelectorAll('button').forEach(b => b.setAttribute('aria-pressed',String(b === button)));
          this.render(cat.id);
          try { sessionStorage.setItem(this.storageKey,cat.id); } catch (_) {}
          this.scrollIntoView({block:'start',behavior:'instant'});
          button.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
        });
        nav.append(button);
      });
      const top = this.node('button','ad-back-top','↑ 回到顶部');
      top.type = 'button';
      top.setAttribute('aria-label','回到页面顶部');
      top.addEventListener('click', () => window.scrollTo({top:0,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}));
      this.append(top);
      this.render(active);
    }
    node(tag, className, text) {
      const n = document.createElement(tag); n.className = className;
      if (text != null) n.textContent = text;
      return n;
    }
    orderedItems(id) {
      const groups = this.catalog.filter(c => !id || c.id === id).map(c => ({
        name:c.name, items:this.items.get(c.id) || [], index:0
      }));
      const seen = new Set(), result = [];
      while (groups.some(g => g.index < g.items.length)) {
        for (const group of groups) {
          while (group.index < group.items.length) {
            const item = group.items[group.index++];
            const key = String(item.asin || item.amazon_url || '').trim().toUpperCase();
            if (!key || seen.has(key)) continue;
            seen.add(key);
            result.push({...item, categoryName:group.name});
            break;
          }
        }
      }
      return result;
    }
    render(id) {
      const list = this.querySelector('.ad-list');
      const selected = this.orderedItems(id);
      const seen = new Set(), fragment = document.createDocumentFragment();
      selected.forEach(d => {
        if (seen.has(d.asin)) return;
        seen.add(d.asin);
        let url;
        try { url = new URL(d.amazon_url); } catch (_) { return; }
        if (url.protocol !== 'https:' || !/(^|\.)amazon\.(ca|com|co\.uk|de|fr|it|es|co\.jp|com\.au)$/.test(url.hostname)) return;
        const card = this.node('a','ad-card'); card.href = url.href; card.target = '_self'; card.rel = 'sponsored';
        const media = this.node('div','ad-media');
        if (d.image && /^https:\/\//i.test(d.image)) {
          const img = document.createElement('img'); img.src = d.image; img.alt = ''; img.width=120; img.height=120; img.loading='lazy'; img.decoding='async';
          img.addEventListener('error',()=>media.replaceChildren(this.node('span','','暂无图片')), {once:true}); media.append(img);
        } else media.textContent='暂无图片';
        const info=this.node('div','ad-info'); info.append(this.node('h3','ad-title',d.title));
        const bottom=this.node('div','ad-bottom'), prices=this.node('div','ad-prices');
        const money=n => new Intl.NumberFormat('en-CA',{style:'currency',currency:d.currency || 'CAD'}).format(n);
        prices.append(this.node('span','ad-price',money(d.current_price)));
        if (d.original_price > d.current_price) prices.append(this.node('s','ad-old',money(d.original_price)));
        if (d.discount_percent > 0) prices.append(this.node('span','ad-discount',d.discount_percent + '% OFF'));
        const meta=[];
        if (d.rating != null) meta.push('★ ' + d.rating);
        if (d.review_count != null) meta.push(Number(d.review_count).toLocaleString('zh-CN') + ' 评价');
        meta.push('Amazon',d.categoryName); bottom.append(prices,this.node('div','ad-meta',meta.join(' · '))); info.append(bottom); card.append(media,info); fragment.append(card);
      });
      list.replaceChildren(fragment);
      if (!list.children.length) list.append(this.node('p','ad-empty','暂无商品'));
    }
  }
  customElements.define('amazon-deals', AmazonDeals);
})();
